/* Megabox parts-depot navigation (snippets/mbs-nav.liquid). */
(() => {
  const nav = document.querySelector('.mbs-nav');
  if (!nav) return;
  const menus = [...nav.querySelectorAll('.mbs-nav__menu')];
  const desktop = window.matchMedia('(min-width: 990px)');
  const closeAll = (except) => menus.forEach((m) => { if (m !== except) m.open = false; });

  // Only one panel open at a time.
  menus.forEach((m) => m.addEventListener('toggle', () => { if (m.open) closeAll(m); }));

  // Desktop: open on hover with a short intent delay.
  menus.forEach((m) => {
    let timer;
    m.parentElement.addEventListener('mouseenter', () => {
      if (!desktop.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => { m.open = true; m.dataset.hoverAt = Date.now(); }, 80);
    });
    // A click right after hover-open shouldn't immediately close the panel.
    m.querySelector('summary').addEventListener('click', (e) => {
      if (desktop.matches && m.open && Date.now() - (m.dataset.hoverAt || 0) < 600) e.preventDefault();
    });
    m.parentElement.addEventListener('mouseleave', () => {
      if (!desktop.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => { m.open = false; }, 150);
    });
  });

  document.addEventListener('click', (e) => { if (!nav.contains(e.target)) closeAll(); });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = menus.find((m) => m.open);
    if (open) { open.open = false; open.querySelector('summary').focus(); }
  });

  // Mobile: single toggle reveals the list.
  const toggle = nav.querySelector('.mbs-nav__mobile-toggle');
  toggle.addEventListener('click', () => {
    const isOpen = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(isOpen));
  });
})();
